/**
 * OVA Product Hero Subscription (PHS) — cart integration.
 * Mirrors Recharge widget behaviour: selling_plan + quantity from plan config.
 */
(function () {
  function parsePlanQtyMap(planDataEl) {
    var map = {};
    if (!planDataEl) return map;
    try {
      JSON.parse(planDataEl.textContent).forEach(function (entry) {
        map[String(entry.id)] = entry.quantity > 0 ? entry.quantity : 1;
      });
    } catch (e) {
      /* ignore malformed JSON */
    }
    return map;
  }

  function restorePhsPrices(wrap) {
    wrap.querySelectorAll('[data-phs-lock]').forEach(function (el) {
      var locked = el.getAttribute('data-phs-lock');
      if (locked && el.textContent.trim() !== locked) {
        el.textContent = locked;
      }
    });
  }

  function lockPhsPrices(wrap) {
    wrap.querySelectorAll('[data-phs-lock]').forEach(function (el) {
      if (el.dataset.phsLocked === 'true') return;

      var locked = el.getAttribute('data-phs-lock');
      if (!locked) return;

      el.dataset.phsLocked = 'true';

      function restore() {
        if (el.textContent.trim() !== locked) {
          el.textContent = locked;
        }
      }

      restore();

      var observer = new MutationObserver(restore);
      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  /**
   * Bind plan selection and add-to-cart for one subscription picker.
   * Looks up form fields inside the wrap so quick-add copies keep working.
   */
  function initPhsWrap(wrap) {
    if (!wrap || wrap.dataset.phsInited === 'true') return;

    var sectionId = (wrap.id || '').replace(/^phs-/, '');
    var spInput =
      wrap.querySelector('input[name="selling_plan"]') ||
      document.getElementById('phs-sp-' + sectionId);
    var planDataEl =
      wrap.querySelector('script[type="application/json"]') ||
      document.getElementById('phs-plans-' + sectionId);
    var form = wrap.closest('form');
    var realBtn =
      (form &&
        (form.querySelector('[name="add"]') ||
          form.querySelector('.product-form__submit'))) ||
      document.getElementById('ProductSubmitButton-' + sectionId);

    if (!form) form = (realBtn && realBtn.closest('form')) || wrap.closest('form');

    if (!form || !spInput) return;

    wrap.dataset.phsInited = 'true';

    var planQtyMap = parsePlanQtyMap(planDataEl);
    var qtyInput = form.querySelector('[name="quantity"]');

    function disableOtherSellingPlanInputs() {
      form.querySelectorAll('input[name="selling_plan"]').forEach(function (inp) {
        if (inp !== spInput) inp.disabled = true;
      });
    }

    function setQuantityForSelection(planId) {
      if (!qtyInput) return;
      var qty = planId && planQtyMap[planId] ? planQtyMap[planId] : 1;
      qtyInput.value = String(qty);
    }

    function setSellingPlan(planId) {
      disableOtherSellingPlanInputs();
      if (planId) {
        spInput.disabled = false;
        spInput.removeAttribute('disabled');
        spInput.value = String(planId);
      } else {
        spInput.value = '';
        spInput.disabled = true;
      }
    }

    function syncFromActiveBox() {
      var activeBox = wrap.querySelector('.phs-box--active');
      if (!activeBox) return;

      if (activeBox.classList.contains('phs-box--one-time')) {
        setSellingPlan('');
        setQuantityForSelection(null);
        return;
      }

      var planId = activeBox.dataset.sellingPlanId;
      if (!planId) return;

      setSellingPlan(planId);
      setQuantityForSelection(planId);
    }

    function activateBox(box) {
      wrap.querySelectorAll('.phs-box').forEach(function (el) {
        var isMe = el === box;
        el.classList.toggle('phs-box--active', isMe);
        var radio = el.querySelector('.phs-radio');
        var content = el.querySelector('.phs-content');
        if (radio) radio.classList.toggle('phs-radio--active', isMe);
        if (content) content.classList.toggle('phs-content--hidden', !isMe);
      });
    }

    wrap.querySelectorAll('[data-phs-pick]').forEach(function (pickEl) {
      function onPick() {
        activateBox(pickEl.closest('.phs-box'));
        syncFromActiveBox();
      }
      pickEl.addEventListener('click', onPick);
      pickEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onPick();
        }
      });
    });

    wrap.querySelectorAll('[data-phs-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('.phs-box');
        if (box) activateBox(box);
        syncFromActiveBox();
        if (!realBtn) return;
        if (form.requestSubmit) {
          form.requestSubmit(realBtn);
        } else {
          realBtn.click();
        }
      });
    });

    form.addEventListener(
      'submit',
      function () {
        syncFromActiveBox();
      },
      true,
    );

    disableOtherSellingPlanInputs();
    syncFromActiveBox();
    lockPhsPrices(wrap);

    return { syncFromActiveBox: syncFromActiveBox };
  }

  function initAll() {
    document.querySelectorAll('.phs-wrap').forEach(initPhsWrap);

    // Recharge / other app scripts may overwrite shared price selectors after load
    [100, 500, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        document.querySelectorAll('.phs-wrap').forEach(restorePhsPrices);
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.quickBuyDrawerOpen, initAll);
  }

  window.initPhsSubscriptions = initAll;
})();
